/* eslint-disable import/extensions */
/* eslint-disable no-shadow */
import React from "react";

// eslint-disable-next-line import/extensions
import { Container } from "./styles";
import CommonActivities from "./CommonActivities";
import AllocationsActivities from "./AllocationsActivities";
import EstimatorActivities from "./EstimatorActivities";
import ActivityByProjects from "./ActivityByProjects";

const Activities: React.FC = () => {
  return (
    <Container>
      <CommonActivities>
        <ActivityByProjects />
        <AllocationsActivities />
        <EstimatorActivities />
      </CommonActivities>
    </Container>
  );
};

export default Activities;
